import {
    addNodeUnderParent,
    removeNodeAtPath,
    changeNodeAtPath
} from 'react-sortable-tree';
import {
    mapDescendants,
    walk
} from '../../../components/helpers/tree-data-utils';
import shortid from 'shortid';

const getNodeKey = ({treeIndex}) => treeIndex;

export const addNewMenuItem = (menuItemsTreeData, node, path, update) => {
    const treeData = addNodeUnderParent({
        treeData: menuItemsTreeData,
        parentKey: path[path.length - 1],
        expandParent: true,
        getNodeKey,
        newNode: {
            id: shortid.generate(),
            name: '',
            new: true,
            parent: node.parent,
            deleted: false,
            expanded: false,
            is_visible: true,
            type: 0,
            href: '',
            clickable: true,
            css_class: null,
            page_id: null,
            page_title: '',
            initial_page_id: null
        },
    }).treeData;

    update(treeData);
};

export const moveMenuItem = (menuItemsTreeData, node, path, nextParentNode, update) => {
    const treeData = changeNodeAtPath({
        treeData: menuItemsTreeData,
        path,
        getNodeKey,
        newNode: {...node, parent: nextParentNode}
    });
    update(treeData);
};

export const disableMenuItem = (menuItemsTreeData, node, path, update) => {
    const treeData = changeNodeAtPath({
        treeData: menuItemsTreeData,
        path,
        getNodeKey,
        newNode: {...node, is_visible: false }
    });

    update(treeData);
};

export const enableMenuItem = (menuItemsTreeData, node, path, update) => {
    const treeData = changeNodeAtPath({
        treeData: menuItemsTreeData,
        path,
        getNodeKey,
        newNode: {...node, is_visible: true}
    });

    update(treeData);
};

export const updateMenuItemCSSClass = (menuItemsTreeData, node, path, cssClass, update) => {
    const treeData = changeNodeAtPath({
        treeData: menuItemsTreeData,
        path,
        getNodeKey,
        newNode: {...node, 'css_class': cssClass}
    });

    update(treeData);
};

export const updateMenuItemExternalLink = (menuItemsTreeData, node, path, externalLink, update) => {
    const treeData = changeNodeAtPath({
        treeData: menuItemsTreeData,
        path,
        getNodeKey,
        newNode: {...node, 'href': externalLink}
    });

    update(treeData);
};

export const addRootMenuItem = (menuItemsTreeData, update) => {
    const treeData = menuItemsTreeData.concat({
        id: shortid.generate(),
        name: '',
        parent: null,
        new: true,
        deleted: false,
        expanded: false,
        is_visible: true,
        type: 0,
        href: '',
        clickable: true,
        css_class: null,
        page_id: null,
        page_title: '',
        initial_page_id: null
    });

    update(treeData);
};

export const removeMenuItem = (menuItemsTreeData, node, path, update) => {

    if (!node.new) {
        let mappedChildren = null;

        if (node.children) {
            mappedChildren = mapDescendants({
                callback: (childNode) => {
                    return {...childNode.node, deleted: true}
                },
                getNodeKey,
                ignoreCollapsed: false,
                isPseudoRoot: true,
                node: {children: node.children},
                currentIndex: -1,
                path: path,
                lowerSiblingCounts: [],
            });
        }

        let treeData = changeNodeAtPath({
            treeData: menuItemsTreeData,
            path: path,
            getNodeKey,
            newNode: {
                ...node,
                deleted: true,
                children: mappedChildren ? mappedChildren.node.children : ''
            }
        });

        update(treeData);
    }

    if (node.new) {
        let treeData = removeNodeAtPath({
            treeData: menuItemsTreeData,
            path,
            getNodeKey
        });

        update(treeData);
    }
};

export const updateMenuItemType = (menuItemsTreeData, node, path, selectedType, update) => {
    let treeData = null;

    if (selectedType === "page") {
        treeData = changeNodeAtPath({
            treeData: menuItemsTreeData,
            path,
            getNodeKey,
            newNode: {...node, 'clickable': true, 'href': null, 'type': 'page'}
        });
    }
    if (selectedType === "link") {
        treeData = changeNodeAtPath({
            treeData: menuItemsTreeData,
            path,
            getNodeKey,
            newNode: {...node, 'page_id': null, 'type': 'link'}
        });
    }
    if (selectedType === "clickable_label") {
        treeData = changeNodeAtPath({
            treeData: menuItemsTreeData,
            path,
            getNodeKey,
            newNode: {...node, 'page_id': null, 'clickable': true, 'href': null, 'type': 'clickable_label'}
        });
    }
    if (selectedType === "heading_label") {
        treeData = changeNodeAtPath({
            treeData: menuItemsTreeData,
            path,
            getNodeKey,
            newNode: {...node, 'page_id': null, 'clickable': false, 'href': null, 'type': 'heading_label'}
        });
    }

    update(treeData);
};

export const updateMenuItemName = (menuItemsTreeData, node, path, name, update) => {
    const treeData = changeNodeAtPath({
        treeData: menuItemsTreeData,
        path,
        getNodeKey,
        newNode: {...node, name: name }
    });

    update(treeData);
};

export const filterData = data => {
    return data.filter(o => {
        if (o.children) {
            o.children = filterData(o.children);
        }
        return o.deleted !== true;
    });
};

export const validateMenuFields = (touched, loading, errorUrl, treeData) => {
    let error = true;
    let errorArray = [];
    
    if (!touched || loading || errorUrl) {
        errorArray.push(true);
    } else {
        walk({
            treeData: treeData,
            getNodeKey,
            callback: ({ node }) => {
              
                if (node.name === '') {
                    errorArray.push(true);
                } else {
                    errorArray.push(false);
                }

                if (node.type === 0) {
                    errorArray.push(true);
                } else {
                    errorArray.push(false);
                }

                if (node.type === "page") {
                    if (node.page_id === null) {
                        errorArray.push(true);
                    } else {
                        errorArray.push(false);
                    }
                } 

                if (node.type === "link" && (node.href === null || node.href === '')) {
                    errorArray.push(true);
                } else {
                    errorArray.push(false);
                }
            },
            ignoreCollapsed: false
        });

        error = errorArray.includes(true);
    }
    
    return error;
}


// WEBPACK FOOTER //
// ./src/containers/menus/utils/menu_operations.js